import { Link } from "react-router-dom";
import Logo from "./Logo";
import { CONTACT_INFO } from "../../data/site";
import SocialIcons from "./SocialIcons";

const COLS = [
  {
    title: "Soluciones",
    links: [
      { label: "CoopSys", to: "/coopsys" },
      { label: "Software Empresarial", to: "/#soluciones", hash: "soluciones" },
      { label: "Cloud", to: "/#cloud", hash: "cloud" },
      { label: "Integraciones", to: "/#integraciones", hash: "integraciones" },
      { label: "Aplicaciones", to: "/servicios" },
    ],
  },
  {
    title: "Empresa",
    links: [
      { label: "Nosotros", to: "/empresa" },
      { label: "Clientes", to: "/clientes" },
      { label: "Blog", to: "/recursos" },
      { label: "Contacto", to: "/contacto" },
    ],
  },
  {
    title: "Soporte",
    links: [
      { label: "Centro de soporte", to: "/contacto" },
      { label: "Documentación", to: "/recursos" },
      { label: "Contacto", to: "/contacto" },
    ],
  },
];

function FooterLink({ link }) {
  const cls = "link-quiet text-sm";
  if (link.hash)
    return (
      <a href={link.to} className={cls}>
        {link.label}
      </a>
    );
  return (
    <Link to={link.to} className={cls}>
      {link.label}
    </Link>
  );
}

export default function Footer() {
  return (
    <footer className="border-t border-border bg-card/40" data-testid="site-footer">
      <div className="wrap grid gap-12 py-16 lg:grid-cols-[1.4fr_1fr_1fr_1fr] lg:gap-8">
        <div className="max-w-sm">
          <Logo />
          <p className="mt-5 text-sm leading-relaxed text-muted-foreground">
            Tecnología para empresas e instituciones que quieren avanzar.
          </p>
          <div className="mt-5 flex flex-col gap-1.5 text-sm">
            <a href={`mailto:${CONTACT_INFO.email}`} className="link-quiet" data-testid="footer-email-link">
              {CONTACT_INFO.email}
            </a>
            <a href="https://www.dasoft.com.do" className="link-quiet" target="_blank" rel="noreferrer">
              {CONTACT_INFO.site}
            </a>
            <a href="tel://18499370818" className="link-quiet" target="_blank" rel="noreferrer">
              {CONTACT_INFO.phone}
            </a>
          </div>
          <SocialIcons testPrefix="footer" bordered className="mt-6" />

        </div>
        {COLS.map((col) => (
          <div key={col.title}>
            <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-foreground">
              {col.title}
            </h3>
            <ul className="mt-5 flex flex-col gap-3">
              {col.links.map((l, i) => (
                <li key={`${l.label}-${i}`}>
                  <FooterLink link={l} />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-border">
        <div className="wrap flex flex-col items-center justify-between gap-4 py-6 text-xs text-muted-foreground sm:flex-row">
          <p>© 2026 DASOFT SRL. Todos los derechos reservados.</p>
          <div className="flex items-center gap-6">
            <a href="#" className="link-quiet">Privacidad</a>
            <a href="#" className="link-quiet">Términos</a>
            <a href="#" className="link-quiet">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
